"use client";
import DomPurify from "isomorphic-dompurify";
import dynamic from "next/dynamic";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";
import BeforeAfterCategories from "./BeforeAfterCategories";
import { BeforeAfterCategoryData } from "./types";
const BeforeAfterCompare = dynamic(() => import("./BeforeAfterCompare"), {
  ssr: false
});

type BeforeAfterProps = {
  title?: string;
  content?: string;
  beforeImageUrl?: string;
  afterImageUrl?: string;
  titleTag: React.ElementType;
  bgColor?: string;
  miniTitle: string;
  wrapperClass?: string;
  beforeLabel?: string;
  afterLabel?: string;
  miniTitleTag?: React.ElementType;
  categories?: BeforeAfterCategoryData[];
  inEditor?: boolean;
};

const BalancedHTMLContent: React.FC<{ htmlContent: string }> = ({ htmlContent }) => {
  return <span dangerouslySetInnerHTML={{ __html: DomPurify.sanitize(htmlContent) }} />;
};

const BeforeAfter = ({
  title,
  bgColor,
  content,
  beforeImageUrl,
  miniTitle,
  wrapperClass,
  afterImageUrl,
  titleTag = "h2",
  miniTitleTag = "h3",
  beforeLabel,
  afterLabel,
  categories,
  inEditor
}: BeforeAfterProps) => {
  const TitleTag = titleTag;
  const MiniTitleTag = miniTitleTag;

  if (!categories?.length && (!beforeImageUrl || !afterImageUrl)) {
    if (inEditor) {
      return (
        <p className="text-center font-medium">
          Add one of (categories) or (beforeImage and afterImage url) props value to render this component.
        </p>
      );
    } else {
      return null;
    }
  }

  return (
    <section style={{ backgroundColor: bgColor }} id="beforeAfter-61" className="relative">
      <MaxWidthWrapper className={wrapperClass}>
        <div className="tile-title-container">
          {miniTitle && <MiniTitleTag className="subby text-center">{miniTitle}</MiniTitleTag>}

          {title ? (
            <TitleTag className="tile-main-header font-heading [text-wrap:balance]">
              <BalancedHTMLContent htmlContent={title} />
            </TitleTag>
          ) : null}
          {content ? <p className="tile-subtitle [text-wrap:balance] ">{content}</p> : null}
        </div>

        {categories?.length ? (
          <BeforeAfterCategories categories={categories} beforeLabel={beforeLabel} afterLabel={afterLabel} />
        ) : beforeImageUrl && afterImageUrl ? (
          <BeforeAfterCompare
            beforeImageUrl={beforeImageUrl}
            afterImageUrl={afterImageUrl}
            beforeLabel={beforeLabel}
            afterLabel={afterLabel}
          />
        ) : null}
      </MaxWidthWrapper>
    </section>
  );
};

export default BeforeAfter;
